import { GrowthBook } from '@growthbook/growthbook-react';
import { ampli } from '../../../ampli';
import { useEffect } from 'react';
import { IUser } from '../../../interfaces/User.interfaces';

const isDevelopment =
  process.env.REACT_APP_CLIENT_ENVIRONMENT === 'development' || process.env.REACT_APP_CLIENT_ENVIRONMENT === 'local';

export const growthbook = new GrowthBook({
  apiHost: process.env.REACT_APP_GROWTH_BOOK_API_HOST,
  clientKey: process.env.REACT_APP_GROWTH_BOOK_CLIENT_KEY,
  enableDevMode: isDevelopment,
  trackingCallback: (experiment, result) => {
    ampli.client.track('Experiment Viewed', {
      experimentId: experiment.key,
      experimentName: experiment.name,
      variantId: result.key,
      variantName: result.name,
    });

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'experiment_viewed', {
        experiment_id: experiment.key,
        experiment_name: experiment.name,
        variant_id: result.key,
        variant_name: result.name,
      });
    }
  },
  plugins: [],
});

const getDeviceAndBrowserInfo = () => {
  const { userAgent, language } = navigator;
  const { devicePixelRatio } = window;

  const platform = (() => {
    if (userAgent.includes('Mac')) return 'macos';
    if (userAgent.includes('Windows')) return 'windows';
    if (userAgent.includes('Linux')) return 'linux';
    if (userAgent.includes('Android')) return 'android';
    if (userAgent.includes('iPhone') || userAgent.includes('iPad')) return 'ios';
    return 'unknown';
  })();

  const isMobile = /iPhone|iPad|iPod|Android/i.test(userAgent);
  const deviceType = isMobile ? 'mobile' : 'desktop';

  const browser = (() => {
    switch (true) {
      case userAgent.includes('Chrome'):
        return 'chrome';
      case userAgent.includes('Firefox'):
        return 'firefox';
      case userAgent.includes('Safari'):
        return 'safari';
      case userAgent.includes('Edge'):
        return 'edge';
      default:
        return 'unknown';
    }
  })();

  return {
    deviceType,
    platform,
    browser,
    language,
    devicePixelRatio,
  };
};

export const setGrowthBookAttributes = (user: IUser) => {
  const deviceAndBrowserInfo = getDeviceAndBrowserInfo();

  growthbook.setAttributes({
    userId: user.id,
    userName: user.name,
    userEmail: user.email,
    ...deviceAndBrowserInfo,
  });
};

export const useGrowthBook = () => {
  useEffect(() => {
    growthbook.init({ streaming: true });
    growthbook.setAttributes({
      ...getDeviceAndBrowserInfo(),
    });
  }, []);
};
